import t from "../../../../helpers/t";
import FormItem from "../../../../components/FormItem";
import React, { useEffect, useState } from "react";

const LocationsChange = (props) => {
  const { params, onChange, setTemp, contingent, setContingent, dispatch } = props;
  const [selectedLocations, setSelectedLocations] = useState(contingent.locations);
  useEffect(() => {
    change();
  }, [selectedLocations]);
  const onChangeLocation = (item) => {
    change();
  };
  const addLocations = (location) => {
    let locationIds = [];
    selectedLocations.map((sel) => {
      locationIds.push({
        id: sel.id,
        name: sel.name,
      });
    });
    locationIds.push({
      id: location.id,
      name: location.name,
    });
    let clone = {};
    Object.assign(clone, contingent);
    console.log(locationIds);
    clone.locations = locationIds;
    setContingent(clone);
  };
  const change = () => {
    let clone = {};
    Object.assign(clone, contingent);
    let locationIds = [];
    selectedLocations.map((sel) => {
      locationIds.push({
        id: sel.id,
        name: sel.name,
      });
    });
    clone.locations = locationIds;
    setContingent(clone);
  };

  const onRemoveLocation = (index) => {
    const newLocations = selectedLocations.slice(0);
    newLocations.splice(index, 1);
    setSelectedLocations(newLocations);
    change();
  };

  const fields = {
    fieldMap: {
      id: {
        label: t("id"),
        number: "1",
        class: "inb-select-width-1",
        type: "default",
        style: { maxWidth: "20%", padding: 0 },
      },
      name: {
        label: t("name"),
        number: "2",
        class: "inb-select-width-3",
        type: "default",
        style: { maxWidth: "35%", padding: 0 },
      },
      description: {
        label: t("description"),
        number: "3",
        class: "inb-select-width-3",
        type: "default",
      },
    },
    fieldNames: ["id", "name", "description"],
  };
  const searchParams = {
    param: "q",
    checkFields: ["name"],
  };
  const disabled = typeof props.disabled !== "undefined" ? props.disabled : "";
  return (
    <>
      <FormItem
        name="locations"
        type="inboomaSelect"
        id={
          "contingents_locations_" + (typeof contingent.id !== "undefined" ? contingent.id : "new")
        }
        sortBy={"name"}
        sortDirection={"asc"}
        advanced={true}
        placeholder={t("select_${a}", { a: t("location") })}
        selectedItems={selectedLocations}
        setSelectedItems={setSelectedLocations}
        onChangeHandler={addLocations}
        dispatch={dispatch}
        container="location-vcard"
        extraStyle={{ maxWidth: "750px" }}
        multiSelect={true}
        onReset={onRemoveLocation}
        fields={fields}
        searchParams={searchParams}
        model={"location"}
        disabled={disabled}
        label={t("location", null, "capital")}
        helpText={t("contingent_location_help")}
        mediumWidth={12}
        smallWidth={12}
      />
    </>
  );
};
export default LocationsChange;
